module.exports = __webpack_public_path__ + "static/media/Orthopedics-Diagnosis History-2@3x.87f5fc8b.png";